import { Component, Input, OnInit } from '@angular/core';
import { PopupRef } from '@app/shared/components/popup/components/popup-ref';
import { PopupConfig } from '../popup-config';

@Component({
  selector: 'app-terms',
  templateUrl: './simple-popup.component.html',
  styleUrls: ['./simple-popup.component.scss']
})
export class SimplePopupComponent implements OnInit {

  title: string;
  message: string;
  buttonText: string;

  constructor(
    private ref: PopupRef,
    private config: PopupConfig
  ) {
    this.title = this.config.data.title;
    this.message = this.config.data.message;
    this.buttonText = this.config.data.buttonText;
  }

  ngOnInit() { }

  close() {
    this.ref.close();
  }

}
